import { render, staticRenderFns } from "./modal-lista-escogidos.vue?vue&type=template&id=4d65797e&scoped=true"
import script from "./modal-lista-escogidos.vue?vue&type=script&lang=js"
export * from "./modal-lista-escogidos.vue?vue&type=script&lang=js"
import style0 from "./modal-lista-escogidos.vue?vue&type=style&index=0&id=4d65797e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65797e",
  null
  
)

export default component.exports